/**
 * Call any method on the localStorage avoiding to throw errors
 * @param {string} method - method we want to call
 * @param {array} args - serialized params that will be proxied to the method we are going to call
 * @returns {null|string} whatever the method call will return
 */
function tryOrFailSilently(method, ...args) {
    try {
        /**
         * Deal with the localStorage avoiding odd issues due to paranoids that have disabled it by default
         */
        const ls = window.localStorage;
        return ls[method].apply(ls, args);
    } catch (e) {
        console && console.error && console.error(e);
        return null;
    }
}

/**
 * Simple object to read get and clear from the localStorage
 */
export default {
    set(item, value) {
        return tryOrFailSilently('setItem', item, value);
    },
    get(item) {
        return tryOrFailSilently('getItem', item);
    },
    clear() {
        return tryOrFailSilently('clear');
    },
    remove(item) {
        return tryOrFailSilently('removeItem', item);
    },
};



// WEBPACK FOOTER //
// ./mcart/assets/src/js/app/util/misc/local-storage.js